const messages = {
  en: {
    // eslint-disable-next-line id-length
    $navigation: {
      company_info: "Company Info",
      company_id: "Company ID",
      organization: "Organization",
      mailroom: "Mailroom",
      sleeksign: "SleekSign",
      sleeksign_send_document: "Send a document",
      sleeksign_document: "Document",
      company_secretary: "Company Secretary",
      accounting: "Accounting",
      acct_packages: "Packages",
      acct_files: "Files",
      referral: "Invite & earn {amount}",
      perks: "Perks",
      billings: "Billings & Subscriptions",
      enquiry: "Enquiry",
      preferences: "Preferences",
      myprofile: "My profile & settings",
      invitations: "Invitations",
      logout: "Log out",
      login: "Log In",
      add_new: "Add company",
      delete_company: "Delete company",
      clear_all_info: "This will clear all the information you entered for:",
      cannot_be_undone: "This action cannot be undone",
      draft_company: "DRAFT COMPANY",
      inprogress_company: "IN PROGRESS",
      cancel: "Cancel",
      shopping_cart: {
        heading: "Summary",
        item: {
          name: "Item Name",
          price: "Price",
        },
        subtotal: "Subtotal",
        buttons: {
          checkout: "CHECKOUT",
        },
      },
      sleeksign_nav: {
        description: "Need to sign a contract?",
        link: "Use SleekSign",
      },
      support: "Support",
    },
    $dashboard: {
      welcome_text_1:
        "Welcome, {firstname}. Here's what you can do to get started.",
      welcome_text_2: "Welcome, {firstname}.",
      get_started_text: "Here’s what you can do to get started.",
      lets_go_text: "Let's go",
      //
      card_header_accounting: "Accounting support",
      card_header_sign: "SleekSign",
      card_header_question: "Have a question?",
      card_header_company: "Your company",
      card_header_documents: "Company documents",
      card_header_mailroom: "Mailroom",
      card_header_company_id: "Company ID",
      fully_incorporated:
        "You can access this after your incorporation is completed.",
      tasks_and_alerts: "tasks and alerts",
      tasks_and_alerts_heading: "Tasks and alerts",
      //
      tile_text_start: "Start a new company",
      tile_text_start_with_sba:
        "Register a new company & get a free business account",
      tile_text_transfer:
        "Transfer existing company secretary or accounting services to Sleek",
      tile_text_sign:
        "Sign documents securely, anywhere in the world. For free!",
      card_text_sign:
        "Our free service for you to sign documents securely, anywhere in the world.",
      card_text_accounting:
        "View available accounting services anytime you need it.",
      card_text_question:
        "Call us at {contact_number}{contact_time}, or email us at",
      //
      card_field_label_registration: "Registration No.",
      card_field_label_status: "Company Status",
      card_field_label_date: "Incorporation Date",
      //
      card_button_get_started: "GET STARTED",
      card_button_quote: "GET A QUOTE",
      card_button_contact: "CONTACT SUPPORT",
      //
      button_view_more: "View More",
      button_view_all: "View all",
      button_accept_invite: "Accept invite",
      //
      card_link_mail: "{email}",
      card_send_enquiry: "Send an enquiry",
      //
      text_snackbar_1:
        "Your KYC Process has been completed! We have completed scanning through your documents and profile details.",
      text_snackbar_2:
        "Welcome to Sleek Platform! We are currently reviewing the documents you have submitted with us as part of our KYC Process.",
      //
      card_text_empty_mailbox: "Your mailbox is empty.",
      //
      alert_message_title_invite: "Invitation",
      you_are_invited_to:
        "You are invited to <strong>{invitingCompanyName}</strong> as <strong>{userRole}</strong>",
      // Perks
      perks_slider_heading: "Get exclusive offers with our partners",
    },
    $auth: {
      title: "Authenticating",
      socials: {
        google: "Continue with Google",
      },
    },
    $login: {
      welcome_v1: "Welcome to",
      welcome: "Welcome Back!",
      password_not_match_records:
        "The email or password does not match our records.",
      tagged_user: "This company will be tagged to your Sleek account",
      email_label: "Email",
      password_label: "Password",
      forgot_password: "Forgot Password?",
      login: "Log In",
      create_account: "Create Account",
      new_to_sleek: "New to Sleek?",
      request_for_reset:
        "Enter your account email address to request for a password reset.",
      instructions_to_reset:
        "Please check your mail inbox for the instruction to reset your password.",
      instructions_to_reset_generic:
        "If your email address exists in our system, we'll send you an email with further instructions.",
      invalid_email: "Please provide a valid email address.",
      incorrect_email_or_password: "Incorrect email or password.",
      submit: "Submit",
      back: "Back",
      error: "Error",
      success: "Success",
      reset_password: "Reset Password",
      new_password: "New password",
      confirm_password: "Confirm password",
      password_length:
        "Password must be <strong>at least 8 characters</strong> long",
      password_uppercase:
        "The password must contain at least one uppercase character (A-Z)",
      password_digit: "The password must contain at least 1 digit (0-9)",
      password_special_char:
        "The password must contain at least 1 special character",
      passwords_do_not_match: "Passwords do not match.",
      reset_successfully: "You have successfully reset your password.",
      logged_in_as: "You are logged in as",
      logout: "Log out",
    },
    $incorporate: {
      stepper: {
        identity_verification: {
          complete_profile: {
            complete_profile_button: "Complete Profile",
          },
        },
      },
    },
    $invitations: {
      next: "Next",
      skip_this: "Skip this",
      radio_yes: "Yes",
      radio_no: "No",
      next_step: "Next step:",
    },
    $accounting: {
      accounting_title:
        "Get covered with Accounting & Tax support that is right for you.",
      plans: [],
      services: [],
      service_add_ons: {},
      service_options: {
        ANNUAL_FILLING_BOOKKEEPING: "Accounting Plan - Annual Bookkeeping",
        ACCOUNTING_PAYROLL: "Accounting Plan - Accounting & Payroll",
        ACCOUNTING_PREMIUM: "Accounting Plan - Accounting Premium",
      },
      bookkeeping: {
        archivedDocuments: "Archived documents",
        stepBySteGuide: "See step-by-step guide",
        frequentlyAskQuestion: "Frequently asked questions",
        needHelpSection:
          "Can’t find what you’re looking for below?  <a href='/support'>Ask us directly.</a>",
      },
      checkout_accounting_plan_text: "Accounting Plan - ",
      checkout_accounting_plan_text_plain: "Accounting Plan",
      pricing_suffix: "/year",
      packages: {
        packages: "Packages",
        accounting_options: "Accounting options",
        para1_title:
          "Choose your monthly expenses and we will provide a quote for you.",
        para1_body:
          "It will be adjusted quarterly if your expenses change over time.",
        para2_body:
          "Get an estimated quote below based on your monthly expenses. Contact us for any enquiry and we will get back to you in 3-5 working days.",
        tooltip1:
          "On average, how much do you spend each month on goods and services that are necessary to your business?",
        tooltip2:
          "Include any payroll or cost of goods sold (COGS) in your estimate. If you’ve paid yourself a draw, do not include this in your expense total.",
        monthly_expenses1: "monthly expenses",
        monthly_expenses2: "Monthly expenses",
        yearly_expenses: "Yearly expenses",
        yearly_revenue: "Yearly revenue",
        revenue_per_year: "revenue per year",
        revenue_per_financial_year: "Revenue per financial year",
        accounting_year_label: "financial year",
        orless: "or less",
        accounting_fees: "Accounting fees",
        payroll_support: "Payroll support",
        multicurrency_support: "Multi-currency support",
        multicurrency_tooltip:
          "Having multi-currency support will allow your book-keeping to account for business transactions done in more than one currency.",
        included_text1: "What's included",
        included_text2:
          "Regardless of your monthly expenses, you will receive the following services:",
        whats_included_packages: [
          "Setup & onboarding",
          "Payroll support with Talenox subscription",
          "Monthly bookkeeping",
          "Monthly management report",
          "Xero & digital receipt submission",
        ],
        plan_details: {
          estimated:
            "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
          estimated_aot:
            "If you do not know your estimated revenue yet, you can always go with the lowest option first.",
          estimated_below_aot: "Select estimated revenue below",
          total_average:
            "What is your total average monthly business expenditure?",
          your_average_monthly:
            "Your average monthly expenses will determine the cost of your plan",
          adjust_your_project:
            "Adjust your projected monthly expenses to see the pricing of our 3 accounting packages.",
          estimated_financial:
            "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
          compared_all: "Compare all plans",
          compare_plan: "Compare plans",
          all_our_plans: ` All our plans include
          <strong>a video call for onboarding and setup, annual company tax return filling, annual review meeting with tax specialist.</strong>`,
          select_your_plans: "Select your estimated revenue per year",
          selected_estimate: "Selected your estimated average monthly expenses",
          dedicated:
            "Dedicated accountant, bookkeeping, employers return, SleekBooks software, unaudited financial statements and smart receipt submission",
          time_to_respond: "Time to respond",
          management_accounts: "Management accounts",
          payroll: "Payroll",
          tax_structuring: "Tax structuring/planning/advice",
          review_with_sen: "Review with Senior Accountant",
          xero_subscription: "Xero subscription",
          xbrl_preparation: "XBRL preparation",
          audit_tax_filing: "Audit & tax filing",
          quarterly_bas_reporting: "Quarterly BAS Reporting",
          bookkeeping: "Bookkeeping",
          cloud_base_receipt_app: "Cloud-based receipt app",
          multi_currency_support: "Multi-currency support",
          video_call_for_onboarding_and_setup: "Onboarding and Setup",
          annual_company_tax_return_filling:
            "Annual company tax return filling",
          annual_review_meeting_with_tax_expert:
            "Annual review meeting with Tax Expert",
          individual_tax_return: "Individual Tax Return",
          expert_support: "Expert support by email, phone, chat",
          xero_subscription_sole_trader: "Xero subscription (starter only)",
          business_income_and_expenses: "Business income and expenses",
          setup_and_onboarding: "Onboarding and setup",
          gst_filling:
            "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
          annual_gst_filing:
            "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
          accounting_options: [],
          accounting_options_popup: [],
          sale_team_in_touch:
            "No problem! Our Sales team will be in touch within 24 hours after you’ve made payment to discuss a suitable plan for your business.",
          faciliate_discussion:
            "To faciliate the discussion, please specify your estimated average monthly expenses.",
          book_a_call:
            "Get a Custom Quote for Your Accounting Plan!<br>Your business deserves a tailored solution. To provide the best pricing for your specific needs, let’s start with a quick chat. Book a call at your convenience, and one of our experts will guide you through your options and answer any questions you may have.",
        },
        whats_included_packages_with_accounting_software: [
          { name: "Payroll support" },
          { name: "Setup & onboarding" },
          { name: "Monthly bookkeeping" },
          { name: "Unaudited Financial Statements" },
          { name: "Monthly management report" },
          { name: "ECI & corporate tax return" },
          { name: "Accounting Software", hasDisclaimer: true },
          { name: "Tax support" },
          { name: "Digital Documents Submission" },
          { name: "Multi-currency support" },
        ],
        whats_included_sub_text:
          "The following services are included for all tiers:",
        accounting_software_disclaimer_text:
          "By default, you get our Sleek accounting software. You can opt-in now or during your onboarding, for the advanced accounting software Xero to access more features.",
        accounting_suggest_plan_text_header:
          "Choose your monthly expenses and we'll suggest a plan that's right for your business.",
        accounting_suggest_plan_text_sub_header:
          "Adjusted quarterly if your expenses change over time.",
        monthly_expense_sub_text: "Includes payroll",
        add_ons_text: "Add-ons",
        contact_us_not_capital: "Contact us",
        per_financial_year_label: "per financial year",
        contact_me_later: "Contact me later",
        request_thankyou:
          "Thank you ! We have taken into account your request and our Accounting team will contact you within 1 business day.",
        backto_dashboard: "Go back to dashboard",
        accounting_package_none: {
          title: "More than {monthlyExpenses} monthly expense?",
          subtitle: "Let us know and we’ll be in touch shortly.",
        },
        xero_subscription: {
          title: "Xero Subscription",
          descriptionClaimer:
            "You can sign up for Xero via Sleek. We get it up and running for you! If you want to decide later, you can opt-in during the accounting onboarding.",
          descriptionNonClaimer:
            "Xero accounting software is included in your package and fully covered by Sleek",
          tooltip: {
            title:
              "Beyond tax & accounting compliance, gain access to more features with Xero:",
            value: [
              "Create your own sales invoice",
              "Connect third party apps",
              "Access your reports anywhere, anytime",
            ],
          },
        },
        xero_subscription_1_year: "Xero Subscription (1 Year)",
        inclusion: {
          monthly_bookkeeping: "Monthly bookkeeping",
          monthly_management_report: "Monthly management report",
          digital_documents_submission: "Digital documents submission",
          setup_onboarding: "Setup & onboarding",
          payroll_support: "Payroll support",
          financial_statements: "Financial Statements",
          track_income_and_expenses: "Track income and expenses",
          multi_currency_support: "Multi-currency support",
        },
        add_xero_subscription: "Add Xero Subscription",
        xero_subscription_sub_title: "Xero - 1 Year Subscription",
        audit_tax_filing: "Audit & tax filing",
        gst_filling_sub_title: "GST Annual Compliance",
        gst_one_time_reg_title: "One-Time GST Registration",
        read_more_link_text: "What is Xero?",
        accounting_software: "Accounting software",
        xero_subscription_optional: {
          unchecked:
            "By default, you get our Sleek Accounting software. Advanced users can opt-in later during the onboarding for Xero at a preferred rate if required.",
          checked: "You have selected Xero as your accounting software.",
        },
        xero_subscription_included:
          "Xero subscription is included with your accounting plan",
        no_plan_selected: "No plan selected",
      },
      files: {
        files: "Files",
        accounting: "Accounting",
        upload: "Upload",
        upload_document: "Upload document",
        upload_title: "Upload a document",
        upload_file: "Upload file",
        download_file: "Download file",
        preview: "Preview",
        rename: "Rename",
        delete: "Delete",
        cancel: "Cancel",
        audit: "Audit",
        tax: "Tax",
        payroll: "Payroll",
        bank_statements: "Bank Statements",
        management_reports: "Management Reports",
        agreements: "Agreements",
        onboarding: "Onboarding",
        accounting_no_access_text:
          "You are not subscribed to our accounting package(s). If you wish to subscribe, please have a chat with us at <a href='mailto:customer@sleek.hk'>customer@sleek.hk</a>",
        status_uploaded: "Uploaded",
        status_uploading: "Uploading...",
      },
      setup: {
        awaiting_email: "Awaiting Email Verification",
        email_sent1: "An email has been sent to your email.",
        email_sent2:
          "Please click on the link in the email to verify this account.",
        resend_email: "RESEND EMAIL",
        refresh_page: "Just refresh this page once verified.",
        success: "Success!",
      },
      accounting_plans: {
        title1: "Accounting plans",
        title2: "Review and payment",
        pay_now: "Pay Now",
        plans: "Plans",
        billing_yearly: "Billing yearly",
        billing_monthly: "Billing monthly",
        no_monthly_billing: "No monthly billing available",
        card_text: "Your accounting plan",
        card_sub_text:
          "Don't worry, if your annual revenue exceeds the limit you could always upgrade the plan – no service disruptions!",
        your_sleek_accounting_package_ready:
          "Your Sleek Accounting package is ready!",
      },
      notification_disable_monthly: "Only yearly plan is available",
      save_price_for_pay_yearly: "Save 25% when you pay yearly",
      no_monthly_billing: "No monthly billing available",
      billing_monthly: "Billed monthly",
      billing_yearly_save_25: "Billed yearly (Save 25%)",
      billing_yearly_mobile: "Billed yearly",
      billing_yearly_save_25_mobile: "Save 25% with yearly billing",
      active_or_dormant_company: {
        card_text: "Is your company active or dormant?",
        card_sub_text:
          "A company can be considered dormant or 'inactive' if it is not conducting business, trading and has no other sources of income during a financial year period.",
        active_company:
          "<p style='font-size: 24px'>Yes</p><p style='font-size: 18px; line-height: 24px'>My company is an <strong>active company</strong></p>",
        dormant_company:
          "<p style='font-size: 24px'>No</p><p style='font-size: 18px; line-height: 24px'>My company is a <strong>dormant company</strong></p>",
      },
      company_or_sold_trader: {
        company: "Proprietary limited company",
        sold_trader: "Sole trader",
        australian_business_number: "What is your Australian Business Number?",
        australian_business_description:
          "It is an 11-digit number that is assigned to your business by the Australian Business Registrar (ABR).",
        what_is_abn: "What is an ABN?",
        australian_business_number_title: "Australian Business Number (ABN)",
        business_info_box_title: "Not registered with the ABR?",
      },
      what_type_of_your_business: "What entity type is your business?",
      dormant_company: {
        accounting_plan_for_dormant_company:
          "Accounting plan for <br /> dormant companies",
      },
      company_name_title: "What is the name of your company?",
      company_name_sub_text:
        "Before incorporating your company in Australia you would need to ensure you have a <strong>unique company name</strong>.",
      company_name_sub_text_2: "Check if your company name is available here. ",
    },
    $onboarding: {
      card: {
        links: {
          discount: "Discount",
        },
      },
      content_paragraph: {
        payment: {
          success: {
            login: "Login successful",
          },
          error: {
            login: "Incorrect email or password.",
          },
          summary: {
            mode_of_payment: {
              title: "Payment method",
              selection: {
                card: "Credit/debit card",
                bank: "Bank transfer",
              },
            },
          },
        },
      },
      start_page_list_text: [
        "Preparing your path to success!",
        "Business made easy",
        "Your business, your way – we’re making it official.",
        "Brace for business excellence!",
        "Hold tight, our app is gearing up!",
        "Your business, our priority – almost there!",
      ],
      page_title: {
        header_support_number: "Need help? Reach us at",
        speak_to_an_advisor: "Speak to an advisor",
        header_support_number_without_help: "Reach us at",
      },
    },
    $public_onboarding: {
      included: "Free",
      country: "",
      navigation: {
        steps: "Steps {current_step} of {total_steps}",
      },
      headers: {
        lets_get_down: "Let's get down to business.",
        nice_to_meet_you: "Nice to meet you,\n{name}!",
        company_director: "Will you be a director of this company?",
        how_many_shareholders: "How many shareholders will you have?",
        name_your_company_transfer_flow: "What is the name of your company?",
        mailroom_mandate: "",
        would_you_like_address:
          "Will your company have a physical location other than your home? | Will {company_name} have a physical location other than your home? | x",
        accounting_header_text: "",
        asic_compliance: "ASIC Compliance",
        registered_address:
          "Ensure your privacy & security with a Registered Office & Digital Mailroom",
        add_ons_service: "Do you need any additional service?",
        youre_doing_great_text:
          "You’re doing great {user_name}! We’re almost done.",
        youre_doing_great: "You’re doing great! We’re almost done.",
        checkout_page_text: "Your bespoke incorporation package",
        bank_transfer: {
          card_text: "Pay with bank transfer",
          card_sub_text:
            "Use these bank details to make your payment from your bank's online banking or mobile app.",
          bank_details:
            "Make sure you include <strong>{invoice_number}</strong> in the Reference/Comments section. This is to help up identify your transaction.",
          bank_transfer_header: "Sleek’s Bank Details",
          receipient_name: "Recipient’s name",
          bank: "Bank",
          account_number: "Account number",
          code_label: "Swift code",
          amount_to_transfer: "Amount to transfer",
          note: "Note: It may take 2 to 3 working days for your bank transfer to reach us.",
          btn_payment: "I’ve made my payment",
          btn_pay_later: "I'll pay later",
          reference_comments: "Reference / Comments",
        },
      },
      sub_headers: {
        asic_compliance:
          "All your ASIC compliance sorted from Day 1, so you can focus on your business.",
        whats_your_name: "First things first, what's your name?",
        whats_your_name_and_email:
          "First things first, what's your name and email address?",
        what_company_name: "What would you like to name your company?",
        before_incorp_unique_company_name:
          "Before incorporating your company in {country_name}, you would need to ensure you have a <strong> unique company name</strong>.",
        always_skip_and_decide_later:
          "Check if your company name is available here. You can always skip this step and decide on your company name later.",
        corporate_secretary_will_keep:
          "Our Corporate Secretary will keep your company on top of all the regulatory affairs. It is priced based on the number of shareholders (irrespective if they are individuals or corporate).",
        they_ensure_legal_compliant:
          "They ensure your company is legally compliant with local law, starting with appointing at least one legally mandated shareholder and one local resident director.",
        must_register_address:
          "We do not support registering residential business addresses. If a residential business address is needed, find more info",
        thinking_of_residential: "",
        mailroom_price_text: "",
        mailroom_too_description: "",
        accounting_sub_header_text: "",
        accounting_sub_header_text2: "",
        add_ons_sub_header_text:
          "Simply click on a service to add it to your accounting package.",
        checkout_page_sub_text:
          "Based on what you told us, we suggest moving forward with the following services:",
      },
      fields: {
        form_label: {
          your_name: "Your first name",
          check_availability: "Check availability",
          company_name: "Company name",
          your_company_name: "Your company name",
          your_email: "Email address",
          checkbox_label:
            "Allow Sleek to stay in touch regarding new products and updates. You can unsubscribe at anytime.",
        },
        placeholder: {
          existing_company_name: "Existing company name",
          company_name_registered:
            "Company name is already registered with Sleek. Enter a different name to transfer.",
          company_name: "Your company name",
          company_name_update: "Your preferred company name",
          quarterly_average: "Estimated average monthly expenses.",
        },
        input: {
          invalid_quarterly: "Invalid quarterly average monthly expense",
        },
      },
      copy: {
        desired_company_names: "Desired company names:",
        no_of_shareholders: "Number of shareholders:",
        any_csh: "Are there any corporate shareholders?",
        add_on_for_csh:
          "If you have corporate shareholder(s), XBRL report preparation will be added to your cart as per required by ACRA.",
        secretary_label: "",
        this_role_text: "This role takes care of:",
        nominee_director_text:
          "As none of your directors are Singapore citizens or PRs, you will need a local Nominee Director to be able to incorporate this company.",
        nominee_director_description: {
          text_1:
            "Both Singapore residents and foreigners can be directors of a Singapore company.",
          text_2:
            "All Singaporean incorporated companies must have at least one resident director on their company's board at all times.",
          text_3:
            "The name 'nominee' indicates the director is strictly non-executive. This service purely satisfies Singapore's law and regulatory compliance.",
        },
        cs_role_description: [
          "Preparation & filing of annual return",
          "Appointments, resignations, & changes in particulars for directors, auditors, secretaries",
          "Distribution of dividends",
          "Maintenance of company records",
          "Overall compliance with local laws and much more",
        ],
        shareholder_role_description: {
          text_1:
            "Singapore incorporated companies must have one shareholder and one local resident director. This can be the same person.",
          text_2: "You can also add more shareholders at a later time.",
        },
        corporate_shareholder_role_description:
          "A corporate shareholder is a business entity that owns shares in another limited company. The term ‘corporate shareholder’ may refer to another limited company, a limited liability partnership or a non-profit organisation or charity",
        accounting_support_message:
          "Choose your projected monthly expense and we'll suggest a plan that's right for your business.",
        satisfaction_guaranteed_text: "100% Satisfaction Guaranteed",
        satisfaction_guaranteed_subtext:
          "We will refund the fees engaged within the first 30 days, should you be unhappy with our service.",
        satisfaction_guaranteed_subtext_with_sleek:
          "We will refund the Sleek fees engaged within the first 30 days, should you be unhappy with our service.",
        what_to_expect_next_text: "What to expect next",
        what_to_expect_steps: [
          {
            message: "Complete your company information",
            duration: "2 mins",
          },
          {
            message: "Register your company address",
            duration: "2 mins",
          },
          {
            message:
              "Invite company members and allocate your company’s shares",
            duration: "10 mins",
          },
          {
            message: "Sign and process documents",
            duration: "2 days",
          },
        ],
      },
      buttons: {
        apply: "APPLY",
        brainstorming: "I'm still brainstorming a name",
        skip_for_now_decide_later: "Skip for now, I'll decide later.",
        get_started: "Get started",
        name_availability: "Check availability",
        check_name: "Check name",
        save_for_later: "Save for later",
        save_for_later_mobile: "Save",
        show_more: "Show more",
        show_less: "Show less",
        add_on_services: "Add-on services",
        need_guidance: "Need Guidance?",
        pay: "PAY",
        remove: "Remove",
      },
      toggle_buttons: {
        toggle_yes: "Yes",
        toggle_no: "No",
        has_csh: "I have a corporate shareholder(s)",
        no_csh: "I don't have a corporate shareholder",
      },
      accordion: {
        company_secretary: {
          title: "Company secretary",
        },
        nominee_director: {
          title: "Refundable security deposit of S$2,000 applies",
          content:
            "This will be waived if you sign up for <b>any</b> of our accounting plans (starting from S$900 / financial year) later.",
        },
        shareholders: {
          title: "Shareholders",
        },
        corporate_shareholders: {
          title: "Corporate Shareholders",
        },
        considered_expense: {
          title: "What is included?",
          p_1: "There are several types of expenses in a business. The most common way to categorize them is into operating vs. non-operating and fixed vs. variable.",
          p_2: "Operating expenses a business incurs through its normal business operations such as:",
          operating_expenses: [
            "Cost of Goods Sold (COGS)  – for example: cost of labour, cost of materials, etc",
            "Marketing, advertising, and promotion",
            "Salaries, benefits, and wages",
            "Selling, general, and administrative (SG&A) –for example:",
            {
              description:
                "cost to sell, cost to deliver, cost to manage the company",
              ls_none: true,
            },
            "Rent and insurance",
            "Depreciation and amortization",
          ],
          p_4: "Non-operating expenses that are not related to normal business operations, such as:",
          non_operating_expenses: ["Interest", "Taxes", "Impairment charges"],
          p_5: "Fixed expenses that does not change and remain the same every month, even though there may be an increase or decrease in business activity in sales or production, such as:",
          fixed_expenses: [
            "Rent",
            "Salaries, benefits, and wages (sometimes fixed and sometimes variable)",
          ],
          p_6: "Variable expenses that keep changing every month depending on the business activity in sales or production, such as:",
          variable_expenses: [
            "Transaction fees",
            "Commissions",
            "Marketing and advertising (sometimes fixed and sometimes variable)",
          ],
        },
      },
      footnote: {
        company_name_availability:
          "* Company name availability subject to final confirmation from regulating authority.",
        terms_and_privacy_text:
          "By registering, you accept our <a href='{terms_url}' target='_blank'>Terms of use</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a>.",
        terms_and_privacy_text_data_processing_addendum:
          "By registering, you accept our <a href='{terms_url}' target='_blank'>Terms of use</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a> and <a href='{data_processing_addendum_url}' target='_blank'>Data Processing Addendum</a>",
      },
      duration_labels: {
        months: "{duration} months",
        one_time: "one time",
        per_year: "/ year",
        calendar_year: "year",
        year: "year",
        financial_year: "financial year",
        per_financial_year: "/ financial year",
        per_financial_year_no_space: "/financial year",
        minutes: "mins",
        days: "days",
        monthly: "month",
      },
      checkout_values: {
        currency_text: "S$",
        whats_included_text: "What's included",
        whats_included_text_straight: "Whats included",
        checkout_button_short: "Proceed to pay",
        checkout_button: "Continue to checkout",
        sub_header: "Save progress and pay later",
        save_package_button: "Save Package",
        edit_package_button: "Edit Package",
        basic_services: [],
        addOn_services: [],
        corporate_secretary_subtext: {
          "corp-sec-1-shareholder": "1 Shareholder",
          "corp-sec-2-shareholder": "2 Shareholders",
          "corp-sec-3-to-5-shareholder": "3 to 5 Shareholders",
          "corp-sec-6-to-9-shareholder": "6-9 Shareholders",
          "corp-sec-10-to-20-shareholder": "10 to 20 Shareholders",
          "corp-sec-21-to-30-shareholder": "21 to 30 Shareholders",
          "corp-sec-31-to-50-shareholder": "31 to 50 Shareholders",
        },
        corporate_shareholders_text: "Company shareholders",
        sub_accounting_adjust_text:
          "Adjust your monthly expenses and we’ll suggest a plan that’s right for your business.",
        sub_accounting_adjust_text_2:
          "Your accounting plan will be adjusted according to your average monthly expenses per financial year. </br> If it falls below or above the selected threshold, we will credit it back to your account or invoice you for the pro-rated amount accordingly.",
        show_more_accounting_included: [],
        show_more_accounting_add_ons_text: "",
        full_accounting_package_included_text: "",
        loading_text: "Loading...",
        up_to: "Up to",
        from: "From",
        to: "to",
        monthly_expense: "monthly expenses",
        more_than: "More than",
      },
      payment_page_values: {
        back_text: "Back",
        great_choice_text: "Great choice!",
        lets_make_it_official_text: "Let's make it official",
        create_account_pay_text: "Create an account and pay",
        lets_get_your_business_started: "Let's get your business started!",
        payment_details_text: "Payment details",
        payment_options: [],
        login_options: [],
        cardholders_name_text: "Cardholders name",
        card_number_text: "Card number",
        expiration_text: "Expiration",
        cvc_text: "",
        your_contact_details_text: "Your contact details",
        sleek_account_details_text: "Sleek account details",
        first_name_text: "First name",
        last_name_text: "Last name",
        email_text: "Email",
        country_code_text: "Country code",
        phone_text: "Phone",
        phone_optional_text: "Phone number (optional)",
        phone_number_text: "Phone number",
        all_fields_required_text: "*All fields are required",
        new_user: "New User",
        existing_user: "Existing User",
        allow_sleek_to_stay_in_touch_text:
          "Allow Sleek to stay in touch regarding new products and marketing updates. You can unsubscribe anytime.",
        by_signing_up_text:
          "By signing up you agree to our <a href='{terms_url}' target='_blank'>Terms & Conditions</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a>.",
        by_signing_up_text_data_compliance:
          "By signing up you agree to our <a href='{terms_url}' target='_blank'>Terms & Conditions</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a> and <a href='{data_processing_addendum_url}' target='_blank'>Data Processing Addendum</a>",
        additional_fee:
          "A S$30 processing fee will be added for payments made via bank transfer or PayNow to account for the manual processing required by our Finance team. Card payments are exempt from any processing fees.",
        trusted_by:
          "<p>Trusted by over <strong>{number_of_companies}</strong> businesses</p>",
        reviews_number: "{number_of_reviews} Google reviews",
      },
      images: {
        loader: "onboarding-loading.gif",
      },
      label_included: "Included",
      cart_summary_services: [],
      total: "Total",
      cart_summary: "Cart Summary",
      cart_summary_accounting: {
        accounting_tax:
          "Accounting Plan - Accounting & Tax </br> ({price} annual revenue)",
        accounting_annual_filling:
          "Annual Bookkeeping - up to {price} Monthly expenses",
        accounting_payroll:
          "Accounting & Payroll - up to {price} Monthly expenses",
        accounting_premium:
          "Accounting Premium - up to {price} Monthly expenses",
        above_value: "Accounting - Above {price} Monthly expenses",
        accounting_tax_return_only:
          "Tax and return only - {price} annual revenue",
        accounting_tax_payroll:
          "Acounting, Tax & Payroll - {price} annual revenue",
        sole_trader_tax_accounting:
          "Sole Trader Tax & Accounting - {price} annual revenue",
        sole_trader_tax_return:
          "Sole Trader Tax Return - {price} annual revenue",
        tax_return_only: "Tax and return only - {price} annual revenue",
      },
      looking_for_help: "Looking for help with your existing company?",
      book_a_call: "Book a call",
      free: "FREE",
      one_hour: "one hour",
      incorporation_assistance: "Incorporation assistance fee",
      company_registry_fee: "Incorporation fee for company registry",
      accounting_none_selected_text:
        "Accounting - More than {moneyValue} monthly expenses",
      pending_quotation: "Pending Quotation",
      add_voucher: "Add voucher code",
      payment_completion_values: {
        thank_you_text: "Thank you!",
        after_payment_recieved:
          "After your payment is received by Sleek, you will be able to proceed to the next steps.",
        title_text: "",
        after_payment_steps: [],
        complete_button_text: "",
        payment_complete:
          "Use the PayNow details to make your payment from your bank's online banking or mobile app.",
      },
      save_for_later_page: {
        back_text: "Back",
        have_to_run_text: "Have to run?",
        drop_your_contact_text:
          "Drop your contact details, and we'll email you a link to pick up right where you left off.",
        see_you_soon_text: "See you soon!",
        first_name_text: "First name",
        last_name_text: "Last name",
        email_text: "Email",
        country_code_text: "Country code",
        phone_optional_text: "Phone (optional)",
        phone_text: "Phone",
        save_progress_btn: "Save progress for later",
        send_quote_btn: "Send the quote",
        return_to_homepage_btn: "Return to homepage",
        have_questions_text: "Have questions? Give us a call on",
        first_name_required: "First name is required.",
        last_name_required: "Last name is required.",
        email_required: "Email is required.",
        email_invalid: "Please enter a valid email address.",
        phone_required: "Phone number is required.",
        phone_invalid: "Please enter a valid phone number.",
      },
      need_guidance_page: {
        first_name_text: "First name *",
        last_name_text: "Last name *",
        email_text: "Email address *",
        country_code_text: "Country code",
        phone_optional_text: "Phone number *",
        phone_text: "Phone number *",
        button_submit: "Get in touch",
        button_back: "Go back",
        card_text: "Your Sleek team is here to support you!",
        card_sub_text:
          "Share your contact details, and we'll get in touch to pick up right where you left off.",
        card_sub_text_2: "See you soon!",
        completed_main_text: "Thank you for getting in touch!",
        completed_sub_text_1:
          "One of our advisors will contact you within <b>1 business day</b>.",
        completed_sub_text_2: "Can't wait? Give us a call",
        completed_sub_text_3:
          "You can exit this page or go back to where you left off.",
        banner_main_text: "We’re here to help!",
        banner_sub_text: "Share your progress and get help from our team.",
        banner_action_mobile: "Let’s do it",
      },
      dollar_value: {
        your_sleek_package_text: "Your Sleek Package",
        dollar_value_list: [],
        total: "Total",
        due_today: "<b>Due today</b>",
        vat_inclusive: "(VAT inclusive)",
      },
      manage_financial: {
        title: "How would you manage your financial compliance?",
        description:
          "To maintain compliance, as a business owner, it is necessary to perform fundamental bookkeeping and accounting tasks that are essential for annual filing.",
        need_sleek_accounting_help:
          "<span class='radio-title'>I need Sleek's accounting help</span> <span style='font-family: Montserrat; font-weight: 400; font-size:14px; line-height: 18px'>(from S$900/year)</span>",
        have_covered: "<span class='radio-title'>I have this covered</span>",
        not_sure_yet: "<span class='radio-title'>Not sure yet</span>",
        try_account_sleek: "Try accounting with Sleek",
        easy_100_online:
          "Easy 100% online & paperless process, all your receipt and documents can be submitted online!",
        dedicated_accountant:
          "Dedicated accountants well-versed in Singapore accounting and tax regulations",
        timely_and_effortless:
          "Timely and effortless IRAS Tax Filing with Sleek's dedicated Accountants",
        low_cost_international:
          "Low cost international money transfers with free Sleek Business Account*",
        subject_to_approval: "*Subject to approval",
        did_you_know_with_ND:
          "<strong>Did you know?</strong><br />Signing up for Sleek’s Accounting service could potentially reduce your invoice by up to <strong>S$1424</strong>, as you won’t have to provide a <strong>S$2,000</strong> refundable deposit required with a Sleek nominee director service. ",
        did_you_know_without_ND:
          "<strong>Did you know?</strong><br />Singapore companies are required to<br /><br /><ul><li>File tax returns with Inland Revenue Authority of Singapore (IRAS) by Nov 30th from the second year of incorporation.</li><li>File Estimated chargeable income (ECI) with the IRAS within 3 months of financial year-end.</li><li>Present unaudited financial statements at Annual general meeting (AGM) within 6 months of financial year-end.</li></ul><br />Relax. Sleek ensures deadlines are met. Stay compliant, seamlessly.",
        would_you_like_to_manage:
          "Would you like to manage your books and taxes using Sleek's accounting services?",
        yes_interested:
          "<span style='font-weight: 500; font-family:Montserrat; font-size: 20px; line-height: 24px; color: #5E5873'>Yes</span>",
        no_interested:
          "<span style='font-weight: 500; font-family:Montserrat; font-size: 20px; line-height: 24px; color: #5E5873'>No</span>",
        i_am_interested:
          "<span style='font-weight: 700; font-size: 12px; line-height: 20px; color: #000000; margin-top: 1rem'>I am interested</span>",
        decide_later:
          "<span style='font-weight: 700; font-size: 12px; line-height: 20px; color: #000000; margin-top: 1rem'>I'll decide later</span>",
      },
      accounting: {
        total_average_monthly_business_expenditure:
          "What is your total average monthly business expenditure?",
        select_average_monthly: "Select average monthly expenses",
        select_average_yearly_revenue: "Select average yearly revenue",
        choose_your_accounting_plan_right_for_you:
          "Let’s choose an accounting plan that is right for you",
        accounting_title_sleek_package: "Accounting",
        xero_subscription_basis: "/ financial year",
        your_plan: "Your plan",
        "accounting_&_tax": "Accounting & Tax",
        for_first_financial_year: "for the first financial year",
        after_first_financial_year: "Then, {original_price} /financial year",
        for_first_year: "for the first year",
        after_first_year: "Then, {original_price} /year",
      },
      audit_and_tax: {
        header_text_1: "Need a hand with Audit & Tax Filing?",
        subheader_text_1:
          "Experience a hassle-free tax season with our top-notch CPAs providing 100% online audit and tax filing services.",
        subheader_text_2:
          "Audit of financial statements is mandatory for all companies, except dormant companies, in Hong Kong S.A.R.",
        main_header_text:
          "What is your total average monthly business expenditure?",
        main_subheader_text:
          "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
        select_business_expense: "Select average monthly business expenses",
        main_dropdown_subtext:
          "Your average monthly expenses will determine the cost of your plan",
        whats_included_text:
          "What’s included in our <strong>Audit and Tax Filing Plan</strong>",
        selected_monthly_expense_text: "Selected monthly expense",
        plain_whats_included_text: "What's included",
        audit_plans_list: [],
        whats_included_list: [],
        checkout_title_ext: "(HK${audit_plan_value} Monthly Expenses)",
        audit_and_tax_plans: {
          "15_000_audit_plan": "Audit & Tax (HK$15,000 monthly expenses)",
          "50_000_audit_plan": "Audit & Tax (HK$50,000 monthly expenses)",
          "100_000_audit_plan": "Audit & Tax (HK$100,000 monthly expenses)",
          "200_000_audit_plan": "Audit & Tax (HK$200,000 monthly expenses)",
          "400_000_audit_plan": "Audit & Tax (HK$400,000 monthly expenses)",
          "700_000_audit_plan": "Audit & Tax (HK$700,000 monthly expenses)",
        },
      },
      send_quote: {
        button: "Send me a quote",
        span: "Need more time?",
        cardText: "Need more time?",
        cardSubText: "If you need more time to decide, that's perfectly fine!",
        cardSubText2:
          "<p>Drop your contact details and we'll send you a link to pick up right where you left off.</p>See you soon!",
      },
      remediation: {
        whats_included_text: "What's included",
        card_title: "Accounting & Tax Remediation",
        card_description:
          "Up to <strong>120 transactions</strong> for each past financial year",
        card_title2: "Accounting Remediation",
        card_description2:
          "Up to <strong>100 transactions</strong> for each past financial year",
        package_side_label: "Remediation - <br>{number} past year",
        package_side_label_exceed_amount_remediation_years:
          "Remediation - <br>More than {number} past years",
        description_for_option_exceed_default_year:
          "Remediation - More than {number} past years",
      },
    },
    $shareholder: {
      services: [],
      default_option: "How many shareholders do you have?",
      number_of_shareholder_determine:
        "Number of shareholders will determine the cost of your plan",
      number_of_shareholder_determine_content:
        "Hong Kong incorporated companies must have at least one shareholder. You can also add more shareholders at a later time.",
      what_include: "What's included",
      chose_your_secretary_plan: "Choose your company secretary plan",
      sub_title_2:
        "We include Company Secretary as a default with each incorporation service to satisfy compliance requirements in Hong Kong",
      standard: {
        title: "Standard",
        description: "Minimal changes for starting out",
      },
      premium: {
        title: "Premium",
        description: "Flexible support for evolving needs",
      },
      financial: "/year",
      choose_a_plan: "Choose a plan",
      included_standard_services: [
        "Provision of a Company Secretary and Designated Representative",
        "Filling of Annual Return (filing fee included)",
        "Change in director's particulars and registered office address",
        "Change in business name or business nature to Inland Revenue Department (IRD)",
        "Branch application (HK$80 government fee excluded)",
      ],
      include_premium_services: [
        "Change of company name to Companies Registry (HK$295 government fee excluded)",
        "Allotment of shares",
        "Transfer of shares",
        "Change of director (appointment/cessation)",
      ],
      premium_include: "Everything in Standard plus",
      standard_include: "All company secretary plan include",
      what_included: "What's included",
      tooltip: `<ul>
        <li>Cost of your plan is based on number of shareholders</li>
        <li>A minimum of one shareholder is required for Hong Kong incorporated companies</li>
        <li>You may add more shareholders at a later stage</li>
      </ul>`,
      how_many_shareholder_you_have: "How many shareholders do you have?",
      your_plan: "Your plan",
      card_title: "Corporate Secretary",
      select_shareholder: {
        title: "Select your number of shareholders",
        sub_title:
          "The cost of your plan is based on number of shareholders. You may add more shareholders at a later stage.",
      },
      no_thanks_btn: "No, thanks",
    },
  },
};

export default messages;
